export default __webpack_public_path__ + "static/media/person.cce16556.svg";